import { render, staticRenderFns } from "./TipsCard.vue?vue&type=template&id=7cb94464&"
import script from "./TipsCard.vue?vue&type=script&lang=js&"
export * from "./TipsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports